import React, { useMemo, useState } from "react";
import {
  FaBars,
  FaTachometerAlt,
  FaCalendarAlt,
  FaClipboardList,
  FaUmbrellaBeach,
  FaBullhorn,
  FaSignOutAlt,
  FaTimes,
  FaLaptop
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import logo from "../assets/urbango-white.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Sidebar.css";

function AdminSidebar({ setActivePage, activePage, admin }) {
  const [showMenu, setShowMenu] = useState(false);
  const navigate = useNavigate();
  const profilePic = useMemo(() => logo, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/admin-login");
  };

  const handleMenuItemClick = (page) => {
    setActivePage(page);
    setShowMenu(false);
  };

  return (
    <>
      {!showMenu && (
        <button
          className="btn btn-light shadow-sm rounded-3 glass-burger d-lg-none"
          aria-label="Open Sidebar Menu"
          onClick={() => setShowMenu(true)}
          type="button"
        >
          <FaBars />
        </button>
      )}

      {/* Desktop persistent admin sidebar */}
      <aside className="glass-sidebar d-none d-lg-flex flex-column">
        <div className="glass-header position-relative text-center">
          <img src={logo} alt="Company Logo" className="company-logo img-fluid" />
          <div className="employee-info d-flex flex-column align-items-center mt-2">
            <img src={profilePic} alt="Profile" className="profile-pic" />
           <p className="welcome-text mb-0">Welcome, {admin?.organizationName || "Admin"} 👋</p>

          </div>
        </div>

        <ul className="list-unstyled glass-menu flex-grow-1 mt-3">
          <li className={activePage === "dashboard" ? "active" : ""} onClick={() => handleMenuItemClick("dashboard")}>
            <FaTachometerAlt /> <span>Employee List</span>
          </li>
          <li className={activePage === "attendance" ? "active" : ""} onClick={() => handleMenuItemClick("attendance")}>
            <FaCalendarAlt /> <span>Employee Attendance</span>
          </li>
          <li className={activePage === "leave" ? "active" : ""} onClick={() => handleMenuItemClick("leave")}>
            <FaClipboardList /> <span>Requested Leaves</span>
          </li>
          <li className={activePage === "holiday" ? "active" : ""} onClick={() => handleMenuItemClick("holiday")}>
            <FaUmbrellaBeach /> <span>Holiday List</span>
          </li>
          <li className={activePage === "leavebalance" ? "active" : ""} onClick={() => handleMenuItemClick("leavebalance")}>
            <FaClipboardList /> <span>Leave Balance</span>
          </li>
          <li className={activePage === "announcements" ? "active" : ""} onClick={() => handleMenuItemClick("announcements")}>
            <FaBullhorn /> <span>Announcements</span>
          </li>
          <li className={activePage === "employeetracker" ? "active" : ""} onClick={() => handleMenuItemClick("employeetracker")}>
            <FaLaptop /> <span>Employee tracker</span>
          </li>
        </ul>

        <button className="btn btn-link text-decoration-none logout-btn align-self-start" onClick={handleLogout}>
          <FaSignOutAlt /> <span>Logout</span>
        </button>
      </aside>

      {/* Mobile/Tablet admin offcanvas */}
      <div
        className={`glass-offcanvas ${showMenu ? "show" : ""}`}
        style={{ visibility: showMenu ? "visible" : "hidden" }}
        aria-modal={showMenu ? "true" : "false"}
        role="dialog"
      >
        <div className="offcanvas-header">
          <img src={logo} alt="Company Logo" className="company-logo img-fluid" />
          <button type="button" aria-label="Close Sidebar" className="offcanvas-close" onClick={() => setShowMenu(false)}>
            <FaTimes />
          </button>
        </div>

        <div className="offcanvas-body d-flex flex-column">
          <div className="employee-info d-flex flex-column align-items-center mb-3">
            <img src={profilePic} alt="Profile" className="profile-pic" />
            <p className="welcome-text">Welcome, {admin.organizationName} 👋</p>

          </div>

          <ul className="list-unstyled glass-menu flex-grow-1">
            <li className={activePage === "dashboard" ? "active" : ""} onClick={() => handleMenuItemClick("dashboard")}>
              <FaTachometerAlt /> <span>Employee List</span>
            </li>
            <li className={activePage === "attendance" ? "active" : ""} onClick={() => handleMenuItemClick("attendance")}>
              <FaCalendarAlt /> <span>Employee Attendance</span>
            </li>
            <li className={activePage === "leave" ? "active" : ""} onClick={() => handleMenuItemClick("leave")}>
              <FaClipboardList /> <span>Requested Leaves</span>
            </li>
            <li className={activePage === "holiday" ? "active" : ""} onClick={() => handleMenuItemClick("holiday")}>
              <FaUmbrellaBeach /> <span>Holiday List</span>
            </li>
            <li className={activePage === "leavebalance" ? "active" : ""} onClick={() => handleMenuItemClick("leavebalance")}>
              <FaUmbrellaBeach /> <span>Leave Balance</span>
            </li>
            <li className={activePage === "announcements" ? "active" : ""} onClick={() => handleMenuItemClick("announcements")}>
              <FaBullhorn /> <span>Announcements</span>
            </li>
            <li className={activePage === "employeetracker" ? "active" : ""} onClick={() => handleMenuItemClick("employeetracker")}>
              <FaLaptop /> <span>Employee Tracker</span>
            </li>
          </ul>

          <button className="btn btn-link text-decoration-none logout-btn text-start mt-2" onClick={handleLogout}>
            <FaSignOutAlt /> <span>Logout</span>
          </button>
        </div>
      </div>

      {/* Offcanvas backdrop */}
      {showMenu && <div className="offcanvas-overlay show" onClick={() => setShowMenu(false)} />}
    </>
  );
}

export default AdminSidebar;
